
import React from "react";

import { useIntl } from "react-intl";

import { styled } from "@mui/styles";

import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import Paper from "@mui/material/Paper";
import Tooltip from "@mui/material/Tooltip";

import LinkIcon from '@mui/icons-material/Link';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import CustomIcon from "../../../components/custom-icon";

export default function CalledServicesSettingsExternalFormList({ calledServiceSettingsList, clientportal }) {
  const intl = useIntl();

  const defaulttextcolor = clientportal?.defaulttextcolor || "primary";
  const defaultcolor = clientportal?.defaultcolor || "primary";

  // Remove itens com ids duplicados (mantém o primeiro)
  const filteredList = React.useMemo(() => {
    if (!Array.isArray(calledServiceSettingsList)) return [];
    const seen = new Set();
    return calledServiceSettingsList.filter(item => {
      if (item.id == null) return true; // mantém itens sem id
      if (seen.has(item.id)) return false;
      seen.add(item.id);
      return true;
    });
  }, [calledServiceSettingsList]);

  function handleItemClick(route) {
    if (!route) return;
    window.open(route, '_blank');
  }

  return (
    <Box
      sx={{
        minHeight: '40vh',
        maxHeight: '70vh',
        overflowY: 'auto',
        p: 3
      }}
    >
      <List sx={{ p: 0 }}>
        {filteredList && filteredList.length > 0 ? (
          filteredList.map((item, idx) => (
            <React.Fragment key={item.id || idx}>
              <Tooltip title={intl.formatMessage({ id: "called.services.settings.external.form.list.open.in.newTab" }, { link: item.RouteText })} placement="top">
                <Paper elevation={2}>
                  <ListItemButton
                    onClick={() => handleItemClick(item.RouteText)}
                    sx={{
                      borderRadius: 2,
                      transition: 'background 0.2s',
                      '&:hover': {
                        backgroundColor: '#e3f2fd',
                        boxShadow: 2,
                      },
                      alignItems: 'flex-start',
                      px: 2,
                      py: 1.5,
                    }}
                  >
                    <ListItemIcon sx={{ minWidth: 36, alignSelf: 'center' }}>
                      <CustomIcon icon={LinkIcon} color={defaultcolor} />
                    </ListItemIcon>

                    <ListItemText
                      primary={
                        <Typography variant="subtitle1" fontWeight={700} color={defaulttextcolor}>
                          {item.title}
                        </Typography>
                      }
                      secondary={
                        <Typography variant="body2" color="text.secondary" sx={{ wordBreak: 'break-all' }}>
                          {item.RouteText}
                        </Typography>
                      }
                    />

                    <ListItemIcon sx={{ alignSelf: 'center' }}>
                      <CustomIcon icon={OpenInNewIcon} color={defaultcolor} />
                    </ListItemIcon>
                  </ListItemButton>
                </Paper>
              </Tooltip>

              {idx < filteredList.length - 1 && <Divider component="li" sx={{ borderColor: 'transparent', mt: 1, mb: 1 }} />}
            </React.Fragment>
          ))
        ) : (
          <ListItemButton disabled sx={{ textAlign: 'center', py: 3 }}>
            <ListItemText primary={intl.formatMessage({ id: "called.services.settings.external.form.list.no.data" })} />
          </ListItemButton>
        )}
      </List>
    </Box>
  );
}